// Imobiliária — real estate, propriedades, alto padrão
// Verde musgo + branco marfim, elegância discreta
module.exports = {
  effect: 'none',
  colors: {
    main:            { light: '#f4f9f5', dark: '#0d1f12' },
    card:            { light: '#e8f2eb', dark: '#142218' },
    surface:         { light: '#d4e8db', dark: '#1c2e20' },
    action:          { light: '#2d6a4f', dark: '#52b788' },
    actionHover:     { light: '#1e4d38', dark: '#40916c' },
    textPrimary:     { light: '#0d1f12', dark: '#f4f9f5' },
    textSecondary:   { light: '#1e3d26', dark: '#c8e6d0' },
    textMuted:       { light: '#4a7c5a', dark: '#74c69d' },
    textMutedSubtle: { light: '#6b9e7a', dark: '#6b9e7a' },
    border:          { light: '#8fbc8f', dark: '#2d5a38' },
    borderSubtle:    { light: '#b8d8be', dark: '#1e3d26' },
    link:            { light: '#2d6a4f', dark: '#52b788' },
    linkBg:          { light: '#f0faf3', dark: 'rgba(45,106,79,0.15)' },
    linkBorder:      { light: '#b7e4c7', dark: '#2d6a4f' },
    linkHover:       { light: '#e0f5e8', dark: 'rgba(45,106,79,0.28)' },
    inputBg:         { light: '#ffffff', dark: '#142218' },
    inputBorder:     { light: '#8fbc8f', dark: '#2d5a38' },
    inputText:       { light: '#0d1f12', dark: '#f4f9f5' },
    focusRing:       { light: '#2d6a4f', dark: '#52b788' },
    overlay:         { light: 'rgba(0,0,0,0.5)', dark: 'rgba(0,0,0,0.75)' },
    confirm:         { light: '#4a7c5a', dark: '#2d5a38' },
    confirmHover:    { light: '#2d6a4f', dark: '#3a6e46' },
    confirmText:     { light: '#ffffff', dark: '#f4f9f5' },
    confirmBg:       { light: '#f4f9f5', dark: '#142218' },
    confirmBorder:   { light: '#b8d8be', dark: '#2d5a38' },
    success:         { light: '#065f46', dark: '#34d399' },
    successHover:    { light: '#022c22', dark: '#10b981' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#10b981', dark: '#6ee7b7' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#b91c1c', dark: '#f87171' },
    errorHover:      { light: '#991b1b', dark: '#ef4444' },
    errorBg:         { light: '#fef2f2', dark: 'rgba(127,29,29,0.3)' },
    errorText:       { light: '#ef4444', dark: '#fca5a5' },
    errorBorder:     { light: '#fecaca', dark: '#7f1d1d' },
    info:            { light: '#1e40af', dark: '#60a5fa' },
    infoHover:       { light: '#1d4ed8', dark: '#3b82f6' },
    infoBg:          { light: '#eff6ff', dark: 'rgba(30,58,138,0.3)' },
    infoText:        { light: '#3b82f6', dark: '#93c5fd' },
    infoBorder:      { light: '#bfdbfe', dark: '#1e3a8a' },
  },
  borderRadius: {
    card:      '24px',
    container: '16px',
    page:      '20px',
    button:    '12px',
    input:     '12px',
    badge:     '8px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '4px',
    device:  '6px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
